import { Section, Eyebrow } from "./Layout";

type Signal = { metric: string; label: string; sub?: string };

const credentials = [
  "ABA Model Rule 7 advertising compliance review on every published page",
  "Attorney-reviewed content, never pure-AI",
  "SOC-conscious workflows — no shared logins, principle of least privilege",
];

const promises = [
  { title: "One firm per market", body: "We work with only one firm per practice area per market. If we take your case, we won't take a competitor's." },
  { title: "Transparent reporting", body: "Every month you see rankings, traffic, calls, forms, and signed cases — not vanity metrics dressed up as ROI." },
  { title: "No long-term lock-in games", body: "12-month engagement because SEO takes that long to compound. No auto-renew traps, no cancellation fees, no data hostage." },
  { title: "Senior team on your account", body: "The strategist who scopes your program is the one who runs it. No bait-and-switch to a junior after signing." },
];

export function TrustSignals({
  eyebrow = "Why firms trust PageOne",
  title = "How every engagement works",
  intro,
  tone = "light",
  semanticSubheadings = false,
  hiddenCredentials = [],
  processNote,
}: {
  eyebrow?: string;
  title?: string;
  intro?: string;
  signals?: Signal[];
  tone?: "light" | "muted";
  semanticSubheadings?: boolean;
  hiddenCredentials?: string[];
  processNote?: string;
}) {
  const wrapper = tone === "muted" ? "bg-secondary/40 border-y border-border" : "bg-background";
  return (
    <div className={wrapper}>
      <Section>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h2 className="mt-4 text-3xl sm:text-4xl font-semibold text-foreground max-w-3xl">{title}</h2>
        {intro && <p className="mt-4 text-lg text-muted-foreground max-w-3xl">{intro}</p>}

        {processNote && <p className="mt-4 text-lg text-muted-foreground max-w-3xl">{processNote}</p>}

        <div className="mt-12 grid lg:grid-cols-2 gap-8">
          <div className="rounded-xl border border-border bg-background p-6">
            {semanticSubheadings ? <h3 className="text-xs uppercase tracking-wider font-semibold text-[var(--gold-deep)]">Compliance & process</h3> : <div className="text-xs uppercase tracking-wider font-semibold text-[var(--gold-deep)]">Compliance & process</div>}
            <ul className="mt-4 space-y-3">
              {credentials.map((c) => (
                <li key={c} className="flex gap-3 text-foreground">
                  <span className="text-[var(--gold-deep)] font-bold flex-shrink-0">✓</span>
                  <span>{c}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-xl border border-border bg-background p-6">
            {semanticSubheadings ? <h3 className="text-xs uppercase tracking-wider font-semibold text-[var(--gold-deep)]">What we promise</h3> : <div className="text-xs uppercase tracking-wider font-semibold text-[var(--gold-deep)]">What we promise</div>}
            <ul className="mt-4 space-y-4">
              {promises.map((p) => (
                <li key={p.title}>
                  <div className="font-semibold text-foreground">{p.title}</div>
                  <div className="mt-1 text-sm text-muted-foreground leading-relaxed">{p.body}</div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Section>
    </div>
  );
}